import { render } from "./SidebarMenuItemBot4.vue?vue&type=template&id=1ee1fed9&scoped=true"
import script from "./SidebarMenuItemBot4.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot4.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot4.vue?vue&type=style&index=0&id=1ee1fed9&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee1fed9"]])

export default __exports__